
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './PreferenceSections.module.scss';
import Checkbox from 'client/components/aria/Checkbox/Checkbox';
// Renders the annotation and map preference sections as a separate unit.
// These controls are mostly independent of the category filtering logic.
const PreferenceSections = ({ owner, checkboxes, onCheckboxChange, dataTestIdBase }) => {
    const canShowDescriptions = Boolean(owner?.hasAnnotations);
    const canShowDimensions = Boolean(owner?.hasDimensions);
    const canShowOverlapping = canShowDescriptions || canShowDimensions;

    const canShowAnnotationGroup = canShowOverlapping;
    const canShowMapGroup = Boolean(owner?.hasCustomBackdropMap);

    return (
        <>
            {canShowAnnotationGroup && (
                <hgroup className={styles.sectionGroup}>
                    <h3 className={styles.heading}><FormattedMessage id='isolatedViews.annotations.heading' /></h3>
                    {canShowDescriptions && (
                        <Checkbox
                            variant='xs'
                            id={`${owner.dataProviderId}.checkbox.descriptions`}
                            isSelected={checkboxes.descriptions}
                            onChange={() => onCheckboxChange('descriptions')}
                            data-testid={`${dataTestIdBase}.checkbox.descriptions`}
                        >
                            <FormattedMessage id='isolatedViews.annotations.descriptions' />
                        </Checkbox>
                    )}
                    {canShowDimensions && (
                        <Checkbox
                            variant='xs'
                            id={`${owner.dataProviderId}.checkbox.dimensions`}
                            isSelected={checkboxes.dimensions}
                            onChange={() => onCheckboxChange('dimensions')}
                            data-testid={`${dataTestIdBase}.checkbox.dimensions`}
                        >
                            <FormattedMessage id='isolatedViews.annotations.dimensions' />
                        </Checkbox>
                    )}
                    {canShowOverlapping && (
                        <Checkbox
                            variant='xs'
                            id={`${owner.dataProviderId}.checkbox.overlapping`}
                            isSelected={checkboxes.overlapping}
                            onChange={() => onCheckboxChange('overlapping')}
                            data-testid={`${dataTestIdBase}.checkbox.overlapping`}
                        >
                            <FormattedMessage id='isolatedViews.annotations.overlapping' />
                        </Checkbox>
                    )}
                </hgroup>
            )}

            {canShowMapGroup && (
                <hgroup className={styles.sectionGroup}>
                    <h3 className={styles.heading}><FormattedMessage id='isolatedViews.maps.heading' /></h3>
                    <Checkbox
                        variant='xs'
                        id={`${owner.dataProviderId}.checkbox.standardMap`}
                        isSelected={checkboxes.standardMap}
                        onChange={() => onCheckboxChange('standardMap')}
                        data-testid={`${dataTestIdBase}.checkbox.standardMap`}
                    >
                        <FormattedMessage id='isolatedViews.maps.standard' />
                    </Checkbox>
                    <Checkbox
                        variant='xs'
                        id={`${owner.dataProviderId}.checkbox.customMap`}
                        isSelected={checkboxes.customMap}
                        onChange={() => onCheckboxChange('customMap')}
                        data-testid={`${dataTestIdBase}.checkbox.customMap`}
                    >
                        <FormattedMessage id='isolatedViews.maps.custom' />
                    </Checkbox>
                </hgroup>
            )}
        </>
    );
};

PreferenceSections.propTypes = {
    owner: PropTypes.shape({
        hasAnnotations: PropTypes.bool,
        hasDimensions: PropTypes.bool,
        hasCustomBackdropMap: PropTypes.bool,
        dataProviderId: PropTypes.string.isRequired
    }).isRequired,
    checkboxes: PropTypes.shape({
        descriptions: PropTypes.bool,
        dimensions: PropTypes.bool,
        overlapping: PropTypes.bool,
        standardMap: PropTypes.bool,
        customMap: PropTypes.bool
    }).isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    dataTestIdBase: PropTypes.string.isRequired
};

export default PreferenceSections;
